var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebookIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4131 0.84375H1.41309C1.14787 0.84375 0.893515 0.949107 0.705979 1.13664C0.518443 1.32418 0.413086 1.57853 0.413086 1.84375V17.8438C0.413086 18.109 0.518443 18.3633 0.705979 18.5509C0.893515 18.7384 1.14787 18.8438 1.41309 18.8438H10.0281V11.8837H7.69009V9.15875H10.0281V7.15875C10.0281 4.83375 11.4481 3.56675 13.5281 3.56675C14.2271 3.56475 14.9271 3.60075 15.6231 3.67375V6.09375H14.1881C13.0601 6.09375 12.8401 6.63175 12.8401 7.41875V9.15375H15.5371L15.1871 11.8787H12.8391V18.8438H17.4131C17.6783 18.8438 17.9327 18.7384 18.1202 18.5509C18.3077 18.3633 18.4131 18.109 18.4131 17.8438V1.84375C18.4131 1.57853 18.3077 1.32418 18.1202 1.13664C17.9327 0.949107 17.6783 0.84375 17.4131 0.84375V0.84375Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook-icon.e218b94b8d987aeea94cd5777adee3d7.svg";